import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import useMediaQuery from '@mui/material/useMediaQuery';

//
export function Team(props: any) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [page, setPage] = useState(0);
    const [people, setPeople] = useState<any[]>([]);

    const showSingle = useMediaQuery(theme.breakpoints.down(900)); // lower then 600px!
    const team: any[] = t("team2", { returnObjects: true });

    // So that preloaded images are not removed after some time idle!
    const [preLoadedImgs, setPreLoadedImgs] = useState<any[]>([]);

    const handlePrevPage = () => {
        if (page - 1 >= 0) {
            setPage(page - 1);
        }
    }

    const handleNextPage = () => {
        if (page + 1 < team.length) {
            setPage(page + 1)
        }
    }

    // Pre load team images! So there are no flicker!
    useEffect(() => {
        if (team && team.length > 0) {
            let imgs: any = [];

            team.forEach((t) => {
                const img = new Image();
                img.src = "team/" + t.name + ".jpg";
                imgs.push(img);
            });

            setPreLoadedImgs(imgs);
        }
    }, []);

    //
    useEffect(() => {
        let np: any[] = [];

        if (!showSingle && page < team.length - 2) {
            for (let i = page; i <= page + 2; i++) {
                np.push(team[i]);
            }
        }
        else if (!showSingle && page < team.length - 1) {
            for (let i = page; i <= page + 1; i++) {
                np.push(team[i]);
            }
        }
        else {
            np.push(team[page]);
        }

        //console.log(JSON.stringify(np, null, 2));
        setPeople(np);
    }, [page, showSingle]);

    //
    return (
        <Box id="eternal-dragons-team" className={props.className} style={{ padding: 0 }}>
            <Box>
                <img src="Ornament_SectionBreakTwistedDragons.png" alt="team members top ornament" style={{ maxWidth: "800px", width: "100%", padding: "20px" }} />
            </Box>

            <Typography className="home-whitebox-header">
                {t("home.teamHeader")}
            </Typography>

            <Box style={{ position: "relative", color: "#555555", fontSize: "16px", padding: "10px 0px" }}>
                {t("home.teamText")}
            </Box>

            {<Box style={{ textAlign: "center" }}>
                <Box className="team-info-container">
                    {<ChevronLeftIcon onClick={handlePrevPage} sx={{ color: page > 0 ? "#333333" : "#cccccc", cursor: "pointer", width: "50px", height: "50px", fontSize: "50px", position: "relative", }} />}

                    <Box className="team-info-people-cont">
                        {
                            people.map((el) => {
                                return (
                                    <Box className="home-investor-item" key={el.name} style={{ padding: 0, background: "", maxWidth: "300px", margin: "10px 10px", height: "450px" }}>
                                        <img className="team-info-image" alt="team member image" src={"team/" + el.name + ".jpg"} />

                                        <Box style={{ fontWeight: 700, fontSize: 22, marginTop: "10px", textTransform: "uppercase" }}>
                                            {el.name}
                                        </Box>

                                        <Box style={{ fontWeight: 700, fontSize: 16, padding: "5px 0 0 0 ", marginBottom: 10 }}>
                                            {el.role}
                                        </Box>

                                        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "center", background: "rd", fontWeight: 400, fontSize: "16px", padding: "5px 0 10px 0", color: "#555555", margin: "auto", maxWidth: "250px", position: "relative" }}>
                                            <ul>
                                                {
                                                    el.positions.map((p: any) => {
                                                        return (<li key={p}><Box style={{ paddingBottom: 10, textAlign: "left" }}>{p}</Box></li>);
                                                    })
                                                }
                                            </ul>
                                        </Box>
                                    </Box>
                                )
                            })
                        }
                    </Box>

                    {<ChevronRightIcon onClick={handleNextPage} sx={{ width: "50px", fontSize: "50px", color: page < team.length - 1 ? "#333333" : "#cccccc", cursor: "pointer", position: "relative" }} />}
                </Box>
            </Box>}
        </Box>
    );
}


// Default style!
const TeamStyled = styled(Team)({
    background: "white",
    height: "auto",
    padding: "30px 20px 30px 20px",
    textAlign: "center",
    marginBottom: "100px",
    ".team-info-image": {
        height: "auto",
        width: "100%",
        maxWidth: "270px"
        //border: "1px solid black"
    },
    ".team-info-container": {
        margin: "auto",
        padding: "20px",
        maxWidth: "1100px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    ".team-info-people-cont": {
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "center"
    },
    ['@media (max-width:900px)']: {
        /*".team-info-container": {
            margin: "auto",
            padding: "20px",
            maxWidth: "900px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
        },
        ".team-info-people-cont": {
            display: "flex",           
            justifyContent: "center",
            flexDirection: "column"
        },*/
        ".team-info-image": {
            //maxHeight: "200px",
            height: "auto",
            width: "100%"
            //border: "1px solid black"
        }
    }
});


export default TeamStyled;